import React, { useEffect, useMemo, useState } from 'react';
import { useCanvaAuth } from '../contexts/CanvaAuthContext2.tsx';
import {
  CANVA_TOP_NAV_DEFAULTS,
  CANVA_TOP_NAV_STRING_KEYS,
} from '../config/canvaTopNavStrings.ts';

const MUZAIC_ORIGIN = 'https://muzaic.ai';
const CREATE_SOUNDTRACK_APP_URL = 'https://use.muzaic.ai/soundtracker';

const CanvaTopBar: React.FC = () => {
  const { canvaAuthenticated } = useCanvaAuth();
  const [scrolled, setScrolled] = useState(false);

  const strings = canvaAuthenticated?.env?.strings as Record<string, string> | undefined;

  const t = (key: string) => strings?.[key] ?? CANVA_TOP_NAV_DEFAULTS[key] ?? key;

  const navLinks = useMemo(
    () => [
      {
        label: t(CANVA_TOP_NAV_STRING_KEYS.studio),
        href: `${MUZAIC_ORIGIN}/studio`,
      },
      {
        label: t(CANVA_TOP_NAV_STRING_KEYS.soundtracker),
        href: `${MUZAIC_ORIGIN}/soundtracker`,
      },
      {
        label: t(CANVA_TOP_NAV_STRING_KEYS.about),
        href: `${MUZAIC_ORIGIN}/about`,
      },
    ],
    [strings]
  );

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <nav
      className={`canva-top-bar${scrolled ? ' canva-top-bar--scrolled' : ''}`}
      aria-label={t(CANVA_TOP_NAV_STRING_KEYS.ariaLabel)}
    >
      <div className="canva-top-bar-inner">
        <a
          href={MUZAIC_ORIGIN}
          className="canva-top-bar-logo-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={`${MUZAIC_ORIGIN}/images/Muzaic_Logo_Light.png`}
            alt={t(CANVA_TOP_NAV_STRING_KEYS.logoAlt)}
            className="canva-top-bar-logo"
            height={32}
            width="auto"
          />
        </a>

        <div className="canva-top-bar-links d-none d-lg-flex align-items-center">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="canva-top-bar-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="canva-top-bar-actions">
          <a
            href={CREATE_SOUNDTRACK_APP_URL}
            className="btn canva-top-bar-cta"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t(CANVA_TOP_NAV_STRING_KEYS.ctaCreateSoundtrack)}
          </a>
        </div>
      </div>
    </nav>
  );
};

export default CanvaTopBar;
